import ReportsOfSicknessImportNew from '@/views/constants/reports-of-sickness-import-new';

const state = {
  file: null
};

const getters = {
  reportsOfSicknessNewImportFile: state => state.file
};

const actions = {
  [ReportsOfSicknessImportNew.Actions.SELECT_FILE] ({ commit, dispatch }, file) {
    commit(ReportsOfSicknessImportNew.Mutations.SET_FILE, file);
    commit(ReportsOfSicknessImportNew.Mutations.SET_COMPLETED);
  }
};

const mutations = {
  [ReportsOfSicknessImportNew.Mutations.SET_FILE] (state, payload) {
    state.file = payload;
  }
};

export default {
  namespaced: false,
  state,
  getters,
  actions,
  mutations
};
